import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.98 16.98"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M8.49 16.98C3.81 16.98 0 13.17 0 8.49S3.81 0 8.49 0s8.49 3.81 8.49 8.49-3.81 8.49-8.49 8.49zm0-15.96c-4.12 0-7.47 3.35-7.47 7.47s3.35 7.47 7.47 7.47 7.47-3.35 7.47-7.47-3.35-7.47-7.47-7.47z" }),
      _createElementVNode("path", { d: "M8.49 8.49V.51C4.11.51.51 4.11.51 8.49s3.6 7.98 7.98 7.98z" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "contrast-icon"}) } }